<template>
  <button :class="{'link-active': name === $route.name }" @click="linkSelect({ name: name, params: {id: id} })">
    <div>
      <div class="icon_menu">
        {{ title }}
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'detail-flap',
  props: [
    'name',
    'id',
    'detailDefinitionChanged',
    'visualDefinition',
    'title'
  ],
  methods: {
    linkSelect (to) {
      if (this.name !== this.$route.name && !this.detailDefinitionChanged) {
        this.$emit('flapClicked', this.name)
      }
      if (!this.detailDefinitionChanged || (this.visualDefinition.definition && this.visualDefinition.definition.hideButtons)) {
        this.$router.push(to).catch(() => {})
      } else {
        // Dialog
        let message = this.$ml.get('saveChanges')
        let options = {
          okText: this.$ml.get('save'),
          cancelText: this.$ml.get('continueWithoutSaving'),
          customClass: 'sherpaDialog'
        }
        this.$dialog.confirm(message, options)
          .then(() => {
            this.$emit('continueSaving', to)
          })
          .catch(() => {
            this.$emit('flapClicked', this.name)
            this.$emit('continueWithoutSaving')
            this.$router.push(to).catch(() => {})
          })
      }
    }
  }
}
</script>

<style lang="scss">
</style>
